import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';
import {Translate} from 'views/module';

const ClientSituationPetrify = (props) => {
  const {
    oldData,
    newData,
  } = props;

  const newSituationRns = new Set(
      (newData?.situation?.situations || []).map((situation) => situation.situationRn),
  );
  const petrifiedSituation = (oldData?.situation?.situations || []).find((situation) => {
    return !newSituationRns.has(situation.situationRn);
  });

  return (
    <Stack>
      <Translate
        expression={petrifiedSituation?.summary ?
          'client.ClientDetail.Correspondance.Logs.PetrifySituation.Text' :
          'client.ClientDetail.Correspondance.Logs.PetrifySituation.FallbackText'
        }
        substitute={{
          summary: petrifiedSituation?.summary,
        }}
      />
    </Stack>
  );
};
ClientSituationPetrify.propTypes = {
  oldData: PropTypes.object.isRequired,
  newData: PropTypes.object.isRequired,
};

export default React.memo(ClientSituationPetrify);
